import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ConfigService } from 'app/utils/config-service';
import { TokenFactory } from 'app/utils/token-factory';
import { NotificationEvent } from './notification.model';
import * as signalR from '@aspnet/signalr';

@Injectable()
export class NotificationClient {
    private connection: signalR.HubConnection;
    private notificationUrl: string;

    private _eventReceived: Subject<NotificationEvent> = new Subject<NotificationEvent>();
    public get eventReceived(): Subject<NotificationEvent> {
        return this._eventReceived;
    }

    constructor(private configService: ConfigService, private tokenFactory: TokenFactory) {
        this.notificationUrl = this.configService.getEnv('notification');
    }

    startConnection(): void {
        if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
            return;
        }

        this.buildConnection();
        this.connection.start().then(() => {
            this.addEventListener();
            console.log('Connected to hub');
        }).catch(error => {
            console.log(error);
            setTimeout(() => this.startConnection(), 5000);
        });

        this.connection.onclose((error) => {
            if (error) {
                console.log(error);
                setTimeout(() => this.startConnection(), 5000);
            }
        });
    }

    closeConnection(): void {
        if (!this.connection || this.connection.state === signalR.HubConnectionState.Disconnected) { return; }

        this.connection.stop().then(() => {
            console.log('Disconnected from hub');
        }).catch((error) => console.log(error));
    }

    private buildConnection(): void {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(this.notificationUrl + 'events', {
                accessTokenFactory: () => { return this.tokenFactory.validateToken(); }
            })
            .configureLogging(signalR.LogLevel.Information)
            .build();
    }

    private addEventListener(): void {
        this.connection.on('NotificationEvent', (result: any) => {
            this.eventReceived.next(new NotificationEvent(result));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/notifications/notification-client.ts